import React from 'react';

import { rgba } from 'polished';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { HeaderButton } from 'components/header-button';
import IconMenuBk from 'components/icons/menu-bk';
import RefreshIcon from 'components/icons/refresh';
import useMediaQuery from 'hooks/use-media-query';
import { useOrderHref } from 'hooks/use-order-href';

import { StyledHeader } from './offers-heading';
import { useOffersUIContext } from './offers-ui-context';

export { headerHeight } from 'components/header';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${Styles.color.red};
`;

const StyledRefreshIcon = styled(RefreshIcon)`
  margin-block-start: 4px;
  fill: ${Styles.color.white};
`;

const StyledOrderIcon = styled(IconMenuBk)`
  margin-block-start: 4px;
  fill: ${Styles.color.white};
`;

const RedHeader = styled(StyledHeader)`
  background-color: ${Styles.color.red};
`;

const ButtonsContainer = styled.div`
  display: flex;
  background-color: ${rgba(Styles.color.grey.one, 0.2)};
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;

const Space = styled.div`
  background-color: ${Styles.color.red};
  width: 1px;
  height: 100%;
`;

export const OffersHeaderBar: React.FC = () => {
  const { formatMessage } = useIntl();
  const { refreshOffers } = useOffersUIContext();
  const menuHref = useOrderHref();
  const isMobile = useMediaQuery('mobile');

  return (
    <Container>
      <RedHeader>{formatMessage({ id: 'offers' })}</RedHeader>
      <ButtonsContainer>
        {isMobile && (
          <>
            <HeaderButton
              label={formatMessage({ id: 'menu' })}
              icon={<StyledOrderIcon />}
              as={StyledLink}
              to={menuHref}
            />
            <Space />
          </>
        )}
        <HeaderButton
          label={formatMessage({ id: 'refresh' })}
          icon={<StyledRefreshIcon height="24px" />}
          onClick={refreshOffers}
          data-testid="manual-refresh-button"
          $displayRoundBorders={false}
        />
      </ButtonsContainer>
    </Container>
  );
};
